var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#419eea"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.3 12.5v.5c0 4.7-3.5 10.1-9.9 10.1-2 0-3.8-.6-5.4-1.6h.8c1.6 0 3.1-.6 4.3-1.5-1.5 0-2.8-1-3.3-2.4.2 0 .4.1.7.1s.6 0 .9-.1c-1.6-.3-2.8-1.7-2.8-3.5.5.3 1 .4 1.6.4-.9-.6-1.6-1.7-1.6-2.9 0-.7.2-1.3.5-1.8 1.7 2.1 4.3 3.5 7.2 3.7-.1-.3-.1-.5-.1-.8 0-1.9 1.6-3.5 3.5-3.5 1 0 1.9.4 2.5 1.1.8-.2 1.5-.4 2.2-.9-.3.8-.8 1.5-1.5 1.9.7-.1 1.4-.3 2-.5-.4.6-1 1.2-1.6 1.7"
  })));
};
export default SvgTwitter;